import jsbn from 'node-forge/lib/jsbn'
import { decode, encode } from './base64'

export function bytesToBigNum(bytes: Uint8Array) {
  const a = []
  const l = bytes.length

  // if we naively encode this, the highest bit is the sign bit.
  // Thus, when we encounter it set, we must add a 0x00 byte in front to denote it's NOT a negative number
  if ((bytes[0] & 0x80) !== 0) {
    a.push(0x00)
  }
  for (let i = 0; i < l; ++i) {
    a.push(bytes[i])
  }
  return new jsbn.BigInteger(a)
}

export function bigNumToBytes(bn: jsbn.BigInteger): Uint8Array {
  return new Uint8Array(bn.toByteArray())
}

/**
 * Convert a base64 string to a BigInteger.
 *
 * If the string is a URL-safe base64 string, pass { url: true } as the second argument. (This is relevant for JWKs)
 */
export function base64ToBigNum(s: string, options?: { url: boolean }) {
  if (options?.url) {
    s = convertBase64UrlToBase64(s)
  }

  return bytesToBigNum(decode(s))
}

export function bigNumToBase64(bn: jsbn.BigInteger) {
  return encode(bigNumToBytes(bn))
}

/**
 * Convert a URL-safe base64 string to a base64 string.
 */
function convertBase64UrlToBase64(input: string) {
  // Replace non-url compatible chars with base64 standard chars
  input = input.replace(/-/g, '+').replace(/_/g, '/')

  // Pad out with standard base64 required padding characters
  const pad = input.length % 4
  if (pad) {
    if (pad === 1) {
      throw new Error(
        'InvalidLengthError: Input base64url string is the wrong length to determine padding'
      )
    }
    input += new Array(5 - pad).join('=')
  }

  return input
}
